import { Box, Divider, Stack, Typography } from '@mui/material'
import { TaskV1TaskActionsServiceComment } from 'c1gen/permissions'
import { HasCapability } from 'components/no-ui/capability'
import { CommentListV2 } from 'components/pages/task/audit/comment/CommentListV2'
import { InlineCommentFormV2 } from 'components/pages/task/audit/comment-form/InlineCommentFormV2'
import { TaskValue } from 'lib/actions/task'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type TaskCommentsProps = {
    task: TaskValue
}

export const TaskComments: FC<TaskCommentsProps> = ({ task }) => <Stack spacing={4} sx={{ mt: 4 }}>
    <Box>
        <Typography variant="h4"><FormattedMessage id="components_task_details_content_tab_details" defaultMessage="Comments" /></Typography>
        <Divider sx={{ mt: 4 }} />
    </Box>
    <Box>
        <HasCapability permission={TaskV1TaskActionsServiceComment}>
            <InlineCommentFormV2 taskId={task.id} />
        </HasCapability>
    </Box>
    <Box>
        <CommentListV2 taskId={task.id} />
    </Box>
</Stack>
